import "react-toastify/dist/ReactToastify.css";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Suspense } from "react";

function App() {
  return (
    <>
      <ToastContainer />
      <Suspense>
        <Outlet />
      </Suspense>
      {/* </LayoutContainer>
      </LayoutRoot> */}
    </>
  );
}

export default App;
